var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-panel-active md_px-20 flex w-full justify-end"},[_c('div',{staticClass:"w-full md_w-10x12 md_px-20"},[_c('div',{staticClass:"w-full md_w-full_80 md_-ml-40"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }